<script lang="ts">
  import { run } from "svelte/legacy";

  import Card from "../atoms/Card.svelte";
  import ErrorText from "../atoms/ErrorText.svelte";
  import NumberInput from "../atoms/NumberInput.svelte";
  interface Props {
    zipcode: any;
    valid?: boolean;
    children?: import("svelte").Snippet;
    hasPressedContinue?: boolean;
  }

  let {
    zipcode = $bindable(),
    valid = $bindable(),
    children,
    hasPressedContinue = $bindable(false),
  }: Props = $props();
  $effect(() => {
    if (zipcode) {
      if (zipcode.toString().length > 5) {
        zipcode = parseInt(zipcode.toString().slice(0, 5));
      }
    } else {
      valid = false;
    }
  });

  $effect(() => {
    valid = (zipcode && zipcode.toString().length === 5) === true;
  });
</script>

<Card class="mb-3 h-auto">
  <div class="mb-3">
    {#if !valid && hasPressedContinue}
      <ErrorText>Vänligen fyll i ett korrekt postnummer för att fortsätta.</ErrorText>
    {:else}
      <div class="mb-3">
        <span class="block text-H5 font-bold">{@render children?.()}</span>
      </div>
    {/if}
  </div>
  <NumberInput
    name={"zipcode"}
    {hasPressedContinue}
    id={"zipCode"}
    error={(zipcode && zipcode.toString().length != 5) || (hasPressedContinue && !valid)}
    class="w-28"
    max={99999}
    bind:value={zipcode}
  />
</Card>
